import { render } from "./text-underline3.vue?vue&type=template&id=9d2b45fe&scoped=true"
const script = {}

import "./text-underline3.vue?vue&type=style&index=0&id=9d2b45fe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2b45fe"],['__file',"src/views/other/cssfx/components/text-underline3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d2b45fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d2b45fe', __exports__)) {
    console.log('reload')
    api.reload('9d2b45fe', __exports__)
  }
  
  module.hot.accept("./text-underline3.vue?vue&type=template&id=9d2b45fe&scoped=true", () => {
    console.log('re-render')
    api.rerender('9d2b45fe', render)
  })

}


export default __exports__